<!--当广告位是信息流是的素材组件-->
<template>
    <div class="uploadType1">
      <span class="placePick">批量上传素材<input class="materialInput"
                                           type="file" @change="onFileChange"
                                           ref="inputFile"
                                           accept="image/jpg,image/jpeg,image/png,image/gif"
                                           multiple></span>
      <p class="err">只能上传JPG、JPEG、PNG、GIF文件，大小不超过150K</p>
      <ad-table :page="pageMaterial" :pageFalse="false" class="imgBox">
        <el-table-column
          label="素材预览"
          align="center"
          slot="firstColumn">
          <template slot-scope="scope">
            <img :src="pageMaterial.data[scope.$index].path" alt="">
          </template>
        </el-table-column>
        <el-table-column
          label="图片名称"
          align="center">
          <template slot-scope="scope">
            <a :href="scope.row.path" target="_blank">{{scope.row.path}}</a>
          </template>
        </el-table-column>
        <el-table-column
          label="是否匹配"
          align="center">
          <template slot-scope="scope">
           <span class="icon iconfont"
                 :class="{'icon-wrong':scope.row.code==='0','icon-right':scope.row.code==='1'}"></span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          align="center">
          <template slot-scope="scope">
            <!--<el-checkbox :value="scope.row.is_shake==='0'?false:true" @change="shock(scope.$index,scope.row.is_shake)">震动-->
            <!---->
           <!--</el-checkbox>-->
            <el-button
              @click="deleteImg(scope.row,scope.$index)"
              class="stopBtn"
              :disabled="disableDel"
              type="primary"
              size="small">
              删除
            </el-button>
          </template>
        </el-table-column>
      </ad-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import adTable from './ad-table.vue';
export default {
  props: {
    adSlot: {
      type: String
    },
    adMS: {
      type: Array
    },
    uploaded: {
      type: Array
    },
    media: {
      type: String
    }
  },
  data () {
    return {
      pageMaterial: { // 静态素材
        headers: { size: '素材尺寸' },
        data: []
      },
      uploadDisable: false,
      disableDel: false,
      tempImg: []
    };
  },
  computed: {
    ...mapGetters({
      uploadMaterial: 'uploadMaterial',
      delMaterial: 'delMaterial',
      delComMaterial: 'delComMaterial'
    })
  },
  created () {
    if (this.$route.params.id) {
      this.pageMaterial.data.push(...this.uploaded);
    }
    if (this.$route.params.type === 'read') {
      this.disableDel = true;
    } else if (this.$route.params.type === 'edit') {
      this.disableDel = false;
    }
  },
  methods: {
    onFileChange (event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files);
    },
    // 过滤出满足条件的图片
    imageValid (file, imgType, imgSize1, imgSize2) {
      /*
           * 素材支持类型及大小限制：
           * 开机全屏：JPG、PNG<100K；GIF<2M
           * 信息流：JPG、PNG<100K
           * */
      let fileArr = [];
      let arr = [];
      let typeArrNo = [];
      let meetArr = [];
      fileArr.slice.call(file).forEach((v, i) => {
        if (imgType.indexOf(v.type) < 0) {
          typeArrNo.push(v.name);
        } else {
          arr.push({ name: v.name, type: v.type, size: v.size });
        }
      });
      file = fileArr.slice.call(file).filter((value) => {
        return typeArrNo.indexOf(value.name) === -1;
      });
      arr.forEach((v, i) => {
        // if (this.media === 'NGA') {
        //   if (imgSize2 && v.size >= imgSize2) {
        //     meetArr.push(v.name)
        //   }
        //   return
        // }
        if (v.type === 'image/jpeg' || v.type === 'image/png' || v.type === 'image/jpg') {
          if (v.size >= imgSize1) {
            meetArr.push(v.name);
          }
        }
        if (v.type === 'image/gif') {
          if (imgSize2 && v.size >= imgSize2) {
            meetArr.push(v.name);
          }
        }
      });
      if (typeArrNo.length > 0 || meetArr.length > 0) {
        let tips = '';
        if (typeArrNo.length > 0) tips += typeArrNo.join(',') + '的格式不正确！';
        // if (meetArr.length > 0) tips += meetArr.join(',') + '的大小不正确！'
        if (meetArr.length > 0) tips = '素材大小有误，请修改！';
        this.$confirm(tips, '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          callback: () => {
          },
          type: 'error'
        });
      }
      file = fileArr.slice.call(file).filter((value) => {
        return meetArr.indexOf(value.name) === -1;
      });
      return file;
    },
    createImage (file) {
      file = this.imageValid(file, ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'], 153600, 2.147484e9);
      if (typeof FileReader === 'undefined') {
        this.$message({
          showClose: true,
          message: '您的浏览器不支持图片上传，请升级您的浏览器！',
          type: 'warning'
        });
        return false;
      }
      let vm = this;
      let leng = file.length;
      let a = 0;
      vm.images = [];
      for (let i = 0; i < leng; i++) {
        let reader = new FileReader();
        reader.onload = function (event) {
          a++;
          vm.images.push(event.target.result);
          if (a === leng) {
            vm.$store.dispatch('getUploadMaterialCode', { file: vm.images, size: vm.adMS }).then(() => {
              if (vm.uploadMaterial.success === 1) {
                vm.tempImg = vm.uploadMaterial.data;
                vm.$emit('tempImg', vm.tempImg);
                vm.uploadMaterial.data.forEach((v, i) => {
                  vm.pageMaterial.data.push({
                    code: v.code,
                    path: v.path,
                    size: v.size,
                    sizeid: v.sizeid,
                    is_shake: '0'
                  });
                  vm.sendData();
                });
              }
            });
            //                vm.clearInputFile()
          }
        };
        reader.readAsDataURL(file[i]);
      }
    },
    // 清空 input[type='file']的value
    clearInputFile () {
      let inputFile = this.$refs.inputFile;
      inputFile.value = '';
      //  inputFile.outerHTML = inputFile.outerHTML
    },
    // 删除上传的图片
    deleteImg (row, index) {
      if (row.id) {
        this.delComMat(row.id, index);
      } else {
        this.$store.dispatch('getDelMaterialCode', { file: [row.path] }).then(() => {
          if (this.delMaterial.success === 1) {
            this.pageMaterial.data.splice(index, 1);
            this.$message({
              showClose: true,
              message: '已删除！',
              type: 'success'
            });
          } else {
            this.$message({
              showClose: true,
              message: '删除失败！',
              type: 'error'
            });
          }
        });
      }
    },
    // 删除提交的图片
    delComMat (id, index) {
      this.$confirm('是否永久删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('getDelComMaterial', { material_id: id }).then(() => {
          if (this.delComMaterial.success === 1) {
            this.pageMaterial.data.splice(index, 1);
            this.sendData();
            this.$message({
              showClose: true,
              message: '已删除！',
              type: 'success'
            });
          } else {
            this.$message({
              showClose: true,
              message: '删除失败！',
              type: 'error'
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    shock (index, shake) {
      if (shake === '0') {
        this.pageMaterial.data.splice(index, 1, {
          code: this.pageMaterial.data[index].code,
          path: this.pageMaterial.data[index].path,
          size: this.pageMaterial.data[index].size,
          sizeid: this.pageMaterial.data[index].sizeid,
          is_shake: '1'
        });
      } else if (shake === '1') {
        this.pageMaterial.data.splice(index, 1, {
          code: this.pageMaterial.data[index].code,
          path: this.pageMaterial.data[index].path,
          size: this.pageMaterial.data[index].size,
          sizeid: this.pageMaterial.data[index].sizeid,
          is_shake: '0'
        });
      }
      this.sendData();
    },
    sendData () {
      this.$emit('uploadedMaterial', this.pageMaterial.data);
    }
  },
  watch: {
    uploaded () {
      this.pageMaterial.data.push(...this.uploaded);
    }
  },
  components: {
    adTable
  }
};
</script>

<style lang="scss" rel="stylesheet/scss">
.uploadType1{
  .imgBox{
    margin-left: 0!important;
  }
}
</style>
